import React, { Component } from "react";

class Section2 extends Component {
  render() {
    return (
      <div className="section2 text-center container-fluid p-5">
        <div className="row">
          <span className="col-sm-1 col-md-1 col-lg-1"></span>
          <div className="col-sm-10 col-md-1- col-lg-10">
            <h1 className="heading13">We are all in this togeather</h1>
            <div className="" style={{width: `90%`,margin: `0 auto`}}>
            <p className="content13">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum vel
              ex dignissimos hic consequatur asperiores quo nisi eos, dolorem
              dolore libero aliquam quae adipisci ipsa ab incidunt? Saepe, modi
              quae.lorem Lorem, ipsum dolor sit amet consectetur adipisicing
              elit. Non nesciunt nihil est ea nostrum, impedit amet dolor
              corrupti enim nulla rerum officia ratione dolore eos voluptatibus
              eius ad. Dolor, omnis.
            </p>
            </div>
          </div>
          <span className="col-sm-1 col-md-1 col-lg-1"></span>
        </div>
      </div>
    );
  }
}

export default Section2;
